import * as client from "../../../client";
import { isValidEffectiveDate } from "../general-input/util";

type NotLinkedReason = "eff_date" | "broker_info" | undefined;
export type WorkflowState =
  | { linked: true }
  | { linked: false; reason: NotLinkedReason; explanation: string };

const explanation = (reason: NotLinkedReason): string => {
  switch (reason) {
    case "eff_date":
      return "This is likely because the report does not have a valid effective date. Please add one in the General tab.";
    case "broker_info":
      return "This is likely because the report does not have all required broker information. Please fill this out in the General tab.";
    case undefined:
      return "This will normally be done within a few minutes.";
  }
};

export const workflowInformation = (
  clientId: string | undefined,
  workflowMetadata: client.WorkflowMetadata | null,
  companyInfo: client.RawCompanyInfo
): WorkflowState => {
  const linked =
    clientId != "bluesky" ||
    !workflowMetadata ||
    (!!workflowMetadata.bluesky_client_folder_url &&
      !!workflowMetadata.bluesky_rater_url &&
      !!workflowMetadata.bluesky_submissions_folder_url &&
      !!workflowMetadata.bluesky_aggregation_folder_url);

  const nonValidEffectiveDate = !isValidEffectiveDate(
    companyInfo.effective_date
  );
  const notAllBrokerInfo =
    (companyInfo.broker_agent_name ?? "") === "" ||
    companyInfo.broker_name === "" ||
    (companyInfo.broker_email ?? "") === "";

  const reason = nonValidEffectiveDate
    ? "eff_date"
    : notAllBrokerInfo
    ? "broker_info"
    : undefined;

  return linked
    ? { linked: true }
    : {
        linked: false,
        reason,
        explanation: explanation(reason),
      };
};
